import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AddComponent } from './components/add/add.component';
import { CheckboxComponent } from './components/checkbox/checkbox.component';
import { DescontoComponent } from './components/desconto/desconto.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { DialogObservationComponent } from './components/observation/dialog-observation/dialog-observation.component';
import { ObservationComponent } from './components/observation/observation.component';
import { DialogRemoveComponent } from './components/remove/dialog-remove/dialog-remove.component';
import { RemoveComponent } from './components/remove/remove.component';
import { RetiradaComponent } from './components/retirada/retirada.component';
import { CoreFeaturesVisiblePasswordModule } from '@brunsker/libs/core/features/visible-password/src';
import { DialogAddComponent } from './components/add/dialog-add/dialog-add.component';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    CoreFeaturesVisiblePasswordModule,
    MatAutocompleteModule,
    NgxMaskDirective,
  ],
  declarations: [
    DialogObservationComponent,
    DialogRemoveComponent,
    RemoveComponent,
    ObservationComponent,
    DialogAddComponent,
    AddComponent,
    RetiradaComponent,
    EditUserComponent,
    DescontoComponent,
    CheckboxComponent,
  ],
  exports: [
    DialogObservationComponent,
    DialogRemoveComponent,
    RemoveComponent,
    ObservationComponent,
    DialogAddComponent,
    AddComponent,
    RetiradaComponent,
    DescontoComponent,
    EditUserComponent,
    CheckboxComponent,
  ],
  providers:[provideNgxMask()]
})
export class CoreUiTableActionsModule {}
